import { WarningOutlined } from '@ant-design/icons'
import { State } from '@hookstate/core'
import { Button, Modal } from 'antd'
import { useTranslation } from 'react-i18next'

type ConfirmModalProps = {
  showModal: State<boolean, {}>
  action: () => void
}
const ConfirmModal = ({ showModal, action }: ConfirmModalProps) => {
  const { t } = useTranslation()
  const widthInPixels: number = 416
  return (
    <Modal
      visible={showModal.get()}
      mask={true}
      onCancel={() => showModal.set(false)}
      maskStyle={{ zIndex: 10001000, background: 'rgba(0,0,0,0.45)' }}
      width={widthInPixels}
      footer={null}
      closable={false}
      centered
      bodyStyle={{ display: 'flex', padding: '32px 32px 24px' }}
    >
      <WarningOutlined style={{ color: '#FAAD14', fontSize: '18px' }} />
      <article style={{ marginLeft: '17px' }}>
        <p style={{ fontSize: '16px', marginBottom: '8px', color: 'black' }}>
          <b>{t('additional-info.warning-title')}</b>
        </p>
        <p style={{ fontSize: '14px', marginBottom: '8px' }}>{t('additional-info.warning-message')}</p>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
          <Button style={{ color: 'black' }} onClick={() => showModal.set(false)}>
            {t('jobs.tasks.cancel')}
          </Button>
          <Button type='primary' style={{ marginLeft: '10px' }} onClick={() => action()}>
            {t('jobs.tasks.changeOptimalStart.modal.continue')}
          </Button>
        </div>
      </article>
    </Modal>
  )
}

export { ConfirmModal }
